import { z } from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'

export const brandCreationSchema = z.object({
  description: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
  countryOfOrigin: z.object(
    { value: z.string().trim(), label: z.string().trim() },
    { required_error: REQUIRED_FIELD_MESSAGE }
  ),
})

export type BrandCreationType = z.infer<typeof brandCreationSchema>
